import type { FC, HTMLAttributes, ReactNode } from "react";

export type SizeContentType = "small" | "medium" | "large";

type Props = HTMLAttributes<HTMLSpanElement> & {
  size?: SizeContentType;
  children: ReactNode;
};

const sizes: { [x in SizeContentType]: number | string } = {
  small: 180,
  medium: 230,
  large: 320,
};

const Content: FC<Props> = (props) => {
  const { size = "small", children, style, ...rest } = props;

  if (!children) {
    return null;
  }

  return (
    <span
      style={{ display: "inline-block", width: "max-content", maxWidth: sizes[size], ...style }}
      {...rest}
    >
      {children}
    </span>
  );
};

export default Content;
